export enum PresenceState {
  Confirmed = 'On Call',
  Early = 'Ringing',
  Available = 'Available',
  Unavailable = 'unavailable',
  Unknown = 'Unknown'
}
